import api from '../api';
import exp from "node:constants"; // your Axios instance

export function createNewsPost(formData: FormData) {
    return api.post('/dashboard/news/store', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
}

export function getNewsPosts() {
    return api.get('/dashboard/news/fetch');
}

export function publishNewsPost(id: number, template_id: number) {
    return api.post(`/dashboard/news/publish/${id}/${template_id}`);
}


export function deleteNewsPost(id: number, template_id: number) {

    const formData = new FormData();

    formData.append('id', String(id));
    formData.append('template_id', String(template_id))

    return api.post('/dashboard/news/delete', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
}

export function getNewsPostById(id: number) {
    return api.get(`/dashboard/news/fetch-single/${id}`);
}

export function updateNewsPost(formData: FormData, id: number) {
    return api.post(`/dashboard/news/update/${id}`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
}

export function getPodcasts() {
    return api.get('/dashboard/podcasts/fetch');
}

export function createPodcast(formData: FormData) {
    return api.post('/dashboard/podcasts/store', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
}

export function getSinglePodcast(id: number) {
    return api.get(`/dashboard/podcasts/fetch-single/${id}`);
}

export function updatePodcasts(formData: FormData, id: number) {
    return api.post(`/dashboard/podcasts/update/${id}`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
}

export function deletePodcast(id: number) {
    const formData = new FormData();

    formData.append('id', String(id));

    return api.post('/dashboard/podcasts/delete', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
}

export function getInsights() {
    return api.get('/dashboard/insights/fetch');
}

export function addInsight(formData: FormData) {
    return api.post('/dashboard/insights/store', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
}

export function getSingleInsight(id: number) {
    return api.get(`/dashboard/insights/fetch-single/${id}`);
}

export function updateInsight(formData: FormData, id: number) {
    return api.post(`/dashboard/insights/update/${id}`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
}

export function deleteInsight(id: number) {
    const formData = new FormData();
    formData.append('id', String(id));

    return api.post('/dashboard/insights/delete', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
}

export function createCustomNews(formData: FormData) {
    console.log(formData);
    return api.post('/dashboard/news/create-custom', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
}

export function getCustomNews(id: number) {
    return api.get(`/dashboard/news/custom/${id}`);
}

export const updateCustomNews = (id: number, data: FormData) => {

    return api.post(`/dashboard/news/update-custom/${id}`, data, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

export function getCustomNewsOrder(id: number) {
    return api.get(`/dashboard/news/fetch-order/${id}`);
}

// Update the component order for a custom news article
export function updateCustomNewsOrder(id: number, components: { id: number, display_order: number }[]) {
    return api.post(`/dashboard/update-order/${id}`, { components });
}
